import { createFileRoute } from "@tanstack/react-router";
import { CoachesPage } from "@/components/coaches/CoachesPage";
import { listCoachPosts } from "@/lib/blog.functions";
import careersCss from "@/careers/careers.css?url";
import { SITE_CHROME_LINKS } from "@/components/site/site-chrome-head";
import { COACHES_ALTERNATES } from "@/components/coaches/coaches-alternates";

const CHROME_LINKS = [
  { rel: "stylesheet", href: careersCss },
];

// /en/coaches — EN locale.

export const Route = createFileRoute("/en/coaches")({
  // Статьи коучей в блоге на языке страницы; сбой чтения — страница без них.
  loader: async () => ({ posts: await listCoachPosts({ data: { lang: "en" } }).catch(() => ({})) }),
  head: () => ({
    meta: [
      { title: "Yolutap coaches — individual career consultations" },
      {
        name: "description",
        content:
          "Yolutap certified coaches — individual career consultations after the diagnostic. We help teenagers turn results into conscious steps toward the future.",
      },
      { property: "og:title", content: "Yolutap coaches — individual career consultations" },
      {
        property: "og:description",
        content:
          "Certified specialists who help the teenager turn diagnostic results into conscious steps toward the future.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://yolutap.com/en/coaches" },
      { property: "og:image", content: "https://yolutap.com/photos/teen_boy_hero.jpg" },
      { property: "og:locale", content: "en_US" },
      { name: "twitter:title", content: "Yolutap coaches — individual career consultations" },
      { name: "twitter:description", content: "Certified specialists who help the teenager turn diagnostic results into conscious steps toward the future." },
    ],
    links: [{ rel: "canonical", href: "https://yolutap.com/en/coaches" }, ...COACHES_ALTERNATES, ...CHROME_LINKS, ...SITE_CHROME_LINKS],
  }),
  component: function Page() {
    const { posts } = Route.useLoaderData();
    return <CoachesPage lang="en" posts={posts} />;
  },
});
